/**
 * Web utilities for OneStamp dashboards.
 */

export function formatRupiah(n) {
  const v = Math.max(0, Math.round(Number(n) || 0));
  // Indonesian thousands separator is "."
  return 'Rp ' + v.toLocaleString('id-ID');
}

export function formatDateTime(iso) {
  if (!iso) return '';
  try {
    return new Date(iso).toLocaleString('en-GB', {
      day: '2-digit', month: 'short', year: 'numeric',
      hour: '2-digit', minute: '2-digit',
    });
  } catch { return iso; }
}

export function formatDate(iso) {
  if (!iso) return '';
  try {
    return new Date(iso).toLocaleDateString('en-GB', {
      day: '2-digit', month: 'short', year: 'numeric',
    });
  } catch { return iso; }
}

/**
 * Defence-in-depth brand isolation check. Any owner/admin-drilldown
 * response that carries `brand_id` MUST match the expected context.
 * Returns the data unchanged on match; throws on mismatch so the caller
 * renders an explicit error state.
 */
export function assertBrandMatch(data, expectedBrandId) {
  if (!data || typeof data !== 'object') return data;
  if ('brand_id' in data && expectedBrandId && data.brand_id !== expectedBrandId) {
    const e = new Error('brand_context_mismatch');
    e.code = 'brand_context_mismatch';
    e.received = data.brand_id;
    e.expected = expectedBrandId;
    throw e;
  }
  return data;
}

export function classes(...parts) {
  return parts.filter(Boolean).join(' ');
}

/**
 * Render an ISO timestamp as relative time (e.g. "3 days ago"). Returns
 * "Never" when null/empty, "Today" within the last 24h.
 */
export function timeAgo(iso) {
  if (!iso) return 'Never';
  try {
    const then = new Date(iso).getTime();
    const now = Date.now();
    const diff = Math.max(0, now - then);
    const min = Math.floor(diff / 60000);
    if (min < 1) return 'Just now';
    if (min < 60) return `${min} min ago`;
    const hr = Math.floor(min / 60);
    if (hr < 24) return `${hr} hr${hr === 1 ? '' : 's'} ago`;
    const d = Math.floor(hr / 24);
    if (d < 30) return `${d} day${d === 1 ? '' : 's'} ago`;
    const mo = Math.floor(d / 30);
    if (mo < 12) return `${mo} mo${mo === 1 ? '' : 's'} ago`;
    const yr = Math.floor(d / 365);
    return `${yr} yr${yr === 1 ? '' : 's'} ago`;
  } catch { return iso; }
}
